export const APP_META_TITLE = 'Discover'
export const APP_META_DESCRIPTION =
  'Discover DeFi yields from top protocols like Aave, Compound, and Morpho. Start earning more from your crypto assets today.'
